<template>
    <div class="trainings">
        <router-view />
    </div>
</template>
